import Headroom from 'headroom.js';

const header = document.querySelector('.header');
const { body } = document;

// Headroom Js
const myElement = header;
const headroom = new Headroom(myElement, {
  offset: 0,
  tolerance: {
    up: 3,
    down: 0,
  },
  classes: {
    initial: 'header--initial',
    pinned: 'header--pinned',
    unpinned: 'header--unpinned',
    top: 'header--top',
    notTop: 'header--not-top',
    bottom: 'header--bottom',
    notBottom: 'header--not-bottom',
  },
});

document.querySelectorAll('.header').forEach(() => {
  headroom.init();
});

// Menu
if (header) {
  const bodyMenuOpen = 'body--menu-open';
  const headerMenuOpen = 'header--menu-open';
  const menu = document.querySelector('.header__menu');
  const buttonOpenMenu = document.querySelector('.header__toggle__button');
  const buttonCloseMenu = document.querySelector('.header__menu__toggle__button');
  const menuHeightTarget = document.querySelector('.header__menu__nav__ul');
  let menuCurrentLevel2 = null;

  // Update container height
  const updateLevel2ContainerHeight = () => {
    if (menuCurrentLevel2) {
      const { height } = menuCurrentLevel2.getBoundingClientRect();
      menuHeightTarget.style.minHeight = `${height}px`;
    } else {
      menuHeightTarget.style.height = null;
    }
  };
  window.addEventListener('resize', updateLevel2ContainerHeight);

  // Open menu
  const openMenu = (event) => {
    body.classList.add(bodyMenuOpen);
    header.classList.add(headerMenuOpen);
    buttonOpenMenu.setAttribute('aria-expanded', body.classList.contains(bodyMenuOpen));
    event.stopPropagation();
    return false;
  };
  buttonOpenMenu.addEventListener('click', openMenu);

  // Close menu
  const closeMenu = () => {
    body.classList.remove(bodyMenuOpen);
    header.classList.remove(headerMenuOpen);
    buttonCloseMenu.removeAttribute('aria-expanded', body.classList.contains(bodyMenuOpen));
  };
  buttonCloseMenu.addEventListener('click', closeMenu);

  // Close menu in click outside
  const clickOutsideMenu = (event) => {
    const isClickInside = menu.contains(event.target);
    if (!isClickInside) {
      body.classList.remove(bodyMenuOpen);
      header.classList.remove(headerMenuOpen);
      buttonCloseMenu.removeAttribute('aria-expanded', body.classList.contains(bodyMenuOpen));
    }
  };
  document.addEventListener('click', clickOutsideMenu);

  // Toggle active submenu
  const menuItems = document.querySelectorAll('button.header__menu__nav__item');
  const menuListItems = document.querySelectorAll('.header__menu__nav__ul__li');
  const menuListItemActive = 'header__menu__nav__ul__li--active';
  const openActiveSubmenu = (event) => {
    const active = document.querySelector('.header__menu__nav__ul__li--active');
    if (active) {
      active.classList.remove(menuListItemActive);
    }
    event.currentTarget.parentElement.classList.add(menuListItemActive);
    menuCurrentLevel2 = event.currentTarget.closest('li').querySelector('ul');
    updateLevel2ContainerHeight();
  };
  menuItems.forEach(button => button.addEventListener('click', openActiveSubmenu));

  // Jump from header nav to submenu
  const navItems = document.querySelectorAll('.header__nav__item');
  const openSubmenu = (event) => {
    if (event.target.tagName !== 'BUTTON') {
      return;
    }
    openMenu(event);
    const position = Array.from(navItems).indexOf(event.target);
    menuListItems.forEach(menulistItem => menulistItem.classList.remove(menuListItemActive));
    menuListItems[position].classList.add(menuListItemActive);
    menuCurrentLevel2 = menuListItems[position].querySelector('ul');
    updateLevel2ContainerHeight();
  };
  navItems.forEach(button => button.addEventListener('click', openSubmenu));
}
